<svg
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  viewBox="0 0 22 22"
  fill="none"
>
  <path
    d="M19.1283 10.8039L14.9203 9.77736L17.052 8.48175C16.4347 6.62233 14.903 5.1124 12.8592 4.61383C11.9173 4.38405 10.973 4.39504 10.0912 4.60741L8.83008 3.78898C10.1512 3.25565 11.646 3.11645 13.1358 3.47988C15.4917 4.05461 17.2798 5.75077 18.071 7.8624L20.1548 6.59587L19.1283 10.8039Z"
    fill="#666666"
  />
  <path
    d="M2.82274 11.2825L7.04208 12.2615L4.92511 13.5811C5.56338 15.4334 7.11198 16.9259 9.16123 17.4014C10.1056 17.6205 11.0497 17.5988 11.929 17.3766L13.1993 18.1807C11.8843 18.7289 10.3912 18.8849 8.89742 18.5383C6.53518 17.9902 4.72809 16.3144 3.91314 14.2119L1.84375 15.5018L2.82274 11.2825Z"
    fill="#666666"
  />
  <rect
    x="8.41016"
    y="7.7019"
    width="5.04093"
    height="2.13035"
    fill="#666666"
  />
  <rect
    x="8.41016"
    y="11.7776"
    width="5.04093"
    height="2.13035"
    fill="#666666"
  />
</svg>
